import { Component, OnInit, Inject } from '@angular/core';
import { AdminService } from '../services/admin.service';
import { ActivatedRoute, Router } from '@angular/router';

import { NgForm } from '@angular/forms';
import { Vendor } from '../../shared/models/vendor.interface';
import { finalize } from 'rxjs/operators';
import { VendorType } from '../../shared/models/vendor.type.interface';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericDialogData } from '../models/generic.dialog.interface';


@Component({
  selector: 'app-edit',
  templateUrl: './vendor.component.html',
  styleUrls: ['./vendor.component.scss']
})
export class VendorComponent implements OnInit {

  constructor(private adminService: AdminService, public dialogRef: MatDialogRef<VendorComponent>, @Inject(MAT_DIALOG_DATA) public data: GenericDialogData) { }
  vendor: Vendor;
  vendorTypes: VendorType[];
  states: string[];
  errors: string;
  isRequesting: boolean;
  ngOnInit() {
    let dealerId = this.adminService.getDealerId();
    let vendorId = this.data.id;

    if (vendorId == null) {
      this.vendor = {} as Vendor;
      this.vendor.vendor_IsActive = true;
    }
    else {
      this.adminService.getVendor(vendorId)
        .subscribe({
          next: (data) => {
            this.vendor = data;
          }
        })
    }

    this.adminService.getVendorTypes(dealerId)
      .subscribe({
        next: (data) => {
          this.vendorTypes = data;
        }
      });

    this.adminService.getStates()
      .subscribe({
        next: (data) => {
          this.states = data;
        }
      });
  }

  saveVendor(form: NgForm) {
    console.log('in vendor onSubmit: ', this.vendor);
    this.errors = '';
    if (form.valid) {
      this.isRequesting = true;

      let dealerId = this.adminService.getDealerId();
      this.vendor.dealer_ID = dealerId;
      
      this.adminService.saveVendor(this.vendor)
        .pipe(finalize(() => this.isRequesting = false))
        .subscribe({
          next: (result) => {
            if (result) {
              this.dialogRef.close();
            }
          },
          error: (error: string) => this.errors = error
        });
    }

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
